module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Langing-page-w720.4ee3e9cf.webp";